/* Rivellor Atelier — app.js (vanilla, no dependencies) */
(function () {
  'use strict';

  /* ---------- Reveal on scroll ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); ro.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { ro.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Countdown timer (persists per visitor) ---------- */
  document.querySelectorAll('[data-countdown-minutes]').forEach(function (el) {
    var mins = parseInt(el.getAttribute('data-countdown-minutes'), 10) || 15;
    var key = 'rivellor_countdown_end';
    var end;
    try {
      end = parseInt(localStorage.getItem(key), 10);
      if (!end || end < Date.now()) {
        end = Date.now() + mins * 60000;
        localStorage.setItem(key, end);
      }
    } catch (err) { end = Date.now() + mins * 60000; }
    function tick() {
      var d = Math.max(0, end - Date.now());
      if (d === 0) { try { localStorage.removeItem(key); } catch (e) {} }
      var m = Math.floor(d / 60000);
      var s = Math.floor((d % 60000) / 1000);
      el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (d > 0) requestAnimationFrame(function () { setTimeout(tick, 250); });
    }
    tick();
  });

  /* ---------- Header search toggle ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var open = searchPanel.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open);
      if (open) searchPanel.querySelector('input').focus();
    });
  }

  /* ---------- Accordions ---------- */
  document.querySelectorAll('.accordion__trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.accordion__item');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
    });
  });

  /* ---------- Rating bars animate in ---------- */
  var bars = document.querySelectorAll('.rating-bar__fill');
  if (bars.length && 'IntersectionObserver' in window) {
    var bo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.width = e.target.getAttribute('data-width') + '%';
          bo.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    bars.forEach(function (b) { bo.observe(b); });
  } else {
    bars.forEach(function (b) { b.style.width = b.getAttribute('data-width') + '%'; });
  }

  /* ---------- Product gallery (display only — no purchase logic) ---------- */
  var productEl = document.querySelector('[data-product]');
  if (!productEl) return;

  var track = productEl.querySelector('.product-gallery__track');
  var slides = track ? Array.prototype.slice.call(track.children) : [];
  var thumbs = Array.prototype.slice.call(productEl.querySelectorAll('.product-gallery__thumb'));
  var dots = Array.prototype.slice.call(productEl.querySelectorAll('.product-gallery__dots span'));

  function goToSlide(i) {
    if (!track || !slides[i]) return;
    track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
  }
  function markActive(i) {
    thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
    dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
  }
  if (track) {
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        markActive(Math.min(i, slides.length - 1));
      }, 80);
    }, { passive: true });
  }
  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goToSlide(i); }); });

  /* Tap-to-zoom */
  slides.forEach(function (slide) {
    slide.addEventListener('click', function (e) {
      var zoomed = slide.classList.toggle('is-zoomed');
      var img = slide.querySelector('img');
      if (zoomed && img) {
        var r = slide.getBoundingClientRect();
        img.style.transformOrigin =
          ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      } else if (img) {
        img.style.transformOrigin = '';
      }
    });
  });
})();
